import LegalLayout from "@/components/LegalLayout";

export default function Evasteet() {
  const openSettings = () => {
    if (window.Cookiebot && typeof window.Cookiebot.renew === "function") {
      window.Cookiebot.renew();
    }
  };
  return (
    <LegalLayout title="Evästekäytäntö" updated="kesäkuu 2026">
      <p>
        Käytämme evästeitä (cookies) parantaaksemme verkkosivujen toimintaa ja käyttökokemusta.
        Voit hyväksyä tai hylätä ei-välttämättömät evästeet sivustolle saapuessasi.
      </p>

      <div>
        <h2>Mitä evästeet ovat</h2>
        <p>Evästeet ovat pieniä tekstitiedostoja, jotka tallentuvat laitteellesi. Osa on
          välttämättömiä sivuston toiminnalle, osaa käytetään vain suostumuksellasi.</p>
      </div>

      <div>
        <h2>Evästeiden ryhmät</h2>
        <ul>
          <li><strong className="text-white">Välttämättömät:</strong> sivuston perustoiminnot, eivät vaadi suostumusta.</li>
          <li><strong className="text-white">Tilastointi / analytiikka:</strong> auttavat ymmärtämään sivuston käyttöä (esim. Google Analytics). Vain suostumuksella.</li>
          <li><strong className="text-white">Markkinointi:</strong> kohdennettu mainonta. Vain suostumuksella.</li>
        </ul>
      </div>

      <div>
        <h2>Suostumuksen hallinta</h2>
        <p>
          Voit muuttaa tai peruuttaa evästesuostumuksesi milloin tahansa alla olevasta painikkeesta.
        </p>
        <button onClick={openSettings} data-testid="cookie-settings-btn"
          className="mt-3 inline-block border border-white/25 text-white text-[13px] font-medium uppercase tracking-[0.12em] px-6 py-3 hover:border-[#ff5a00] hover:text-[#ff5a00] transition-colors">
          Evästeasetukset
        </button>
      </div>

      <div>
        <h2>Evästeluettelo</h2>
        <p>
          Yksityiskohtainen ja automaattisesti päivittyvä luettelo käytetyistä evästeistä julkaistaan
          tällä sivulla evästeiden hallintapalvelun kautta. <span className="ph">[Cookiebot-evästeselvitys lisätään tähän kun palvelu on käytössä]</span>
        </p>
      </div>
    </LegalLayout>
  );
}
